import React, { useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Header from "../../../policy/fragments/heading/index"
import { useSelector } from "react-redux";
import { Iconfont } from "../../../../components/icon/iconfont";
import VipGrade from "./fragments/vip-grade";
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../hooks/common";
import { useState } from "react";
import { fetchVipData } from "../../../../../api";
import VipSkeleton from "../home/skeleton/index"
import { useMemo } from "react";
import VipRewards from "./fragments/vip-rewards";
import VipFaq from "./fragments/vip-faq";
import { useCallback } from "react";
import Cache from "../../../../../utils/cache";
import NormalConfigConfirm from "../../../../../client/components/alert/config-confirm";
import { useIntl } from "react-intl";

const VipBackground = props =>{
    const { currentVipStyle } = props;

    return <div className={cls.VipBackground}>
        <div className={cls.Item1} style={{backgroundImage: `url(${currentVipStyle?.cardBackground})`}}></div>
        <div className={cls.Item2} style={{backgroundImage: `url(${currentVipStyle?.background})`}}></div>
    </div>
}

const Vip =  props =>{
    useStyles(cls);
    const global = useSelector(state=>state.global);
    const { config } = global;
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const { customer } = useSelector(state => state.pageCustomer);

    const [vipData, setVipData] = useState(null);
    const [vipStyles, setVipStyles] = useState(null);
    const [currentLevel, setCurrentLevel] = useState(0);
    const [upgradeFlag, setUpgradeFlag] = useState(false);
    const Intl = useIntl();

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await Vip.fetchData(store, params, query)
		}
    }, []);

    useEffect(async () => {
        if(customer?.id){
            let response = await fetchVipData();
            if(response?.code === 200 && response?.result){
                setVipData(response.result);
                setVipStyles(response.result?.vipStyles);
                setCurrentLevel(response.result?.level);
                initModal(response.result);
            }
        }
    }, [customer?.id]);

    const initModal = useCallback((data) =>{
        const { vipStyles, level:userLevel } = data;
        let cacheLevel = Cache.get("customer_vip_level");
        console.log('cacheLevel', cacheLevel)
        if(cacheLevel == null){
            Cache.set("customer_vip_level", userLevel, (365 * 24 * 60 * 60) * 1000);
            if(userLevel > 0){
                let upGarade = vipStyles[userLevel];
                console.log('upGarade', upGarade)
                upGarade && modalShow(upGarade?.cardImageURL, upGarade?.level);
                setUpgradeFlag(true);
            }
        }else{
            if(cacheLevel < userLevel){
                console.log('To upgrade the pop-up');
                let upGarade = vipStyles[userLevel];
                upGarade && modalShow(upGarade.cardImageURL,upGarade.level);
                Cache.set("customer_vip_level", userLevel, (365 * 24 * 60 * 60) * 1000);
                setUpgradeFlag(true);
            }else{
                console.log('No To upgrade the pop-up')
                Cache.set("customer_vip_level", userLevel, (365 * 24 * 60 * 60) * 1000);
            }
        }
        
    }, []);

    const modalShow = useCallback((image, level) =>{
        NormalConfigConfirm({
            boxStyle:{
                padding:"15px 8px 12px"
            },
            title:{
                text:`${Intl.formatMessage({ id: "congratulations", defaultMessage: "Congratulations" })}!`,
                style:{
                    fontFamily: 'Roboto-Bold'
                }
            },
            message:{
                text:`<img src="${image}" style="width:70%;"/><br/><br/><p style="font-size: 12px;color: #999999;">${Intl.formatMessage({ id: "your_vip_level_to", defaultMessage: "Your VIP level has been level-up to" })} <span style="color: #e64545;">V${level}</span>, ${Intl.formatMessage({ id: "your_new_rewards", defaultMessage: "go check out your new rewards!" })}</p>`,
                style:{
                    lineHeight:"normal",
                    fontFamily: 'Roboto',
                },
                html:true
            },
            btn1:{
                text:Intl.formatMessage({ id: "confirm", defaultMessage: "Confirm" }),
                style:{
                    fontSize:"14px",
                        fontFamily: 'Roboto-Medium',
                        textTransform: 'uppercase',
                        height: "42px",
                        lineHeight: "42px"
                }
            },
        });
    }, []);

    const currentVipStyle = useMemo(() =>{
        if(vipStyles && currentLevel >= 0){
            return vipStyles[currentLevel]
        }
        return null;
    }, [vipStyles, currentLevel]);

    const themeColor = useMemo(() =>{
        if(vipStyles){
            return vipStyles.map(item=>item.theme?.highlight);
        }
        return null;
    }, [vipStyles]);

    const userLevel = useMemo(() =>{
        return vipData?.level || 0;
    }, [vipData]);

    return <div className={cls.UserVip}>
        {
            vipData && vipStyles ? <React.Fragment>
                <Header 
                    centerSlot={`${config?.name} VIP`} 
                    rightSlot={
                        <a href={'/cart'} className={cls.HeaderCart}>
                            <Iconfont className={cls.bigger}>&#xe6a4;</Iconfont>
                            {
                                global.countCart > 0 && <span className={cls.Num}>{global.countCart}</span>
                            }
                        </a>
                    }
                />

                <div className={cls.UserVipContent}>
                    <div className={cls.UserVipContentItem}>
                        <VipGrade 
                            customer={customer} 
                            vipStyles={vipStyles} 
                            currentLevel={currentLevel} 
                            themeColor={themeColor}
                            vipData={vipData}
                            userLevel={userLevel}
                            changeCurrentLevel={(level)=>setCurrentLevel(level)}
                        />

                        <VipRewards 
                            currentLevel={currentLevel} 
                            vipStyles={vipStyles} 
                            currentVipStyle={currentVipStyle}
                            themeColor={themeColor}
                            userLevel={userLevel}
                            upgradeFlag={upgradeFlag}
                        />

                        <VipFaq vipData={vipData} />
                    </div>
                    
                    {
                        currentVipStyle && <VipBackground currentVipStyle={currentVipStyle} />
                    }
                </div>
            </React.Fragment> : <React.Fragment>
                <VipSkeleton />
            </React.Fragment>
        }
        
    </div>
}

Vip.fetchData = async (store, params, search, headers) => {
}

export default Vip;